import { BooleanInput, coerceBooleanProperty } from '@angular/cdk/coercion'
import { NgClass } from '@angular/common'
import { Component, EventEmitter, Input, Output } from '@angular/core'

@Component({
  selector: 'app-button',
  standalone: true,
  imports: [NgClass],
  templateUrl: './button.component.html',
})
export class ButtonComponent {
  @Output() public trigger = new EventEmitter()

  @Input()
  public get disabled(): BooleanInput | boolean {
    return this._disabled
  }

  public set disabled(value: BooleanInput) {
    this._disabled = coerceBooleanProperty(value)
  }

  private _disabled = false

  @Input()
  public htmlType: 'button' | 'submit' | 'reset' = 'button'

  @Input()
  public size: 'default' | 'small' | 'large' = 'default'

  @Input()
  public type: 'default' | 'primary' | 'outline' | 'transparent' = 'default'

  @Input()
  public shape: 'round' | 'circle' = 'round'

  public get defaultType(): boolean {
    return this.type === 'default'
  }

  public get primary(): boolean {
    return this.type === 'primary'
  }

  public get outline(): boolean {
    return this.type === 'outline'
  }

  public get transparent(): boolean {
    return this.type === 'transparent'
  }

  public get small(): boolean {
    return this.size === 'small'
  }

  public get defaultSize(): boolean {
    return this.size === 'default'
  }

  public get large(): boolean {
    return this.size === 'large'
  }

  public get circle(): boolean {
    return this.shape === 'circle'
  }

  public emitTrigger(): void {
    this.trigger.emit()
  }
}
